import React from 'react'
import styled from 'styled-components';
import softwareData from '../../data/softwareData';
import SoftwareProduct from './SoftwareProduct'

const Softwares = () => {
    const products = softwareData();
    return (
        <Container>
            <div className="heading">
                <span>Our Products</span>
                <h4>Our World Class Softwares Products Gives You An Experience You Will Never Forget</h4>
            </div>
            <SoftwareProducts>
                {
                    products.map(item => (
                        <SoftwareProduct
                            item={item}
                        />
                    ))
                }
            </SoftwareProducts>
        </Container>
    )
}

export default Softwares

const Container = styled.div`
    background: #fff;
    .heading{
        text-align: center;
        padding: 0rem 10rem;
        padding-bottom: 1rem;
        span{
        font-weight: 600;
        display: block;
        margin-bottom: 10px;
        color: #e21f36;
        }
        h4{
            color: #000219;
            font-size: 2rem;
            font-weight: 800;
        }
        p{
            color: #000219;
            font-size: 1.2rem;
        }
        @media screen and (max-width: 900px){
            padding: 0rem 1rem;
            /* h4{
                font-size: 1rem;
            } */
        }
    }
`

const SoftwareProducts = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
`